import { request } from '@umijs/max';

// 请求配置类型
type RequestOptions = Record<string, unknown>;

/**
 * 管理员登录
 * @param body 登录参数
 * @param options 请求配置
 * @returns 登录响应
 */
export async function adminLogin(
  body: API.AdminLoginRequest,
  options?: RequestOptions,
) {
  return request<API.AdminLoginResponse>('/api/internal/auth/admin/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/**
 * 获取当前用户信息
 * @param options 请求配置
 * @returns 用户信息响应
 */
export async function getCurrentUser(options?: RequestOptions) {
  return request<{
    code?: number;
    message?: string;
    data?: API.UserDTO;
  }>('/api/internal/auth/me', {
    method: 'GET',
    ...(options || {}),
  });
}

/**
 * 刷新访问令牌
 * @param body 刷新令牌请求
 * @param options 请求配置
 * @returns 新的访问令牌
 */
export async function refreshToken(
  body: { refresh_token: string },
  options?: RequestOptions,
) {
  return request<API.RefreshTokenResponse>('/api/internal/auth/refresh', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/**
 * 用户登出
 * @param options 请求配置
 * @returns 登出结果
 */
export async function logout(options?: RequestOptions) {
  return request<{ message: string }>('/api/internal/auth/logout', {
    method: 'POST',
    ...(options || {}),
  });
}
